import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'VOLUME 1',
  subtitle: 'U6',
  desc: '50 Allenamenti Completi',
  features: 'Coordinazione · Motricità · Primi contatti con il pallone · Giochi educativi'
}, {
  color: '🟡',
  title: 'VOLUME 2',
  subtitle: 'U8',
  desc: '50 Allenamenti Completi',
  features: 'Guida della palla · Passaggio · Ricezione · Mini partite'
}, {
  color: '🟠',
  title: 'VOLUME 3',
  subtitle: 'U10',
  desc: '50 Allenamenti Completi',
  features: 'Tecnica individuale · 1 contro 1 · Possesso palla · Finalizzazione'
}, {
  color: '🔴',
  title: 'VOLUME 4',
  subtitle: 'U12',
  desc: '50 Allenamenti Completi',
  features: 'Smarcamento · Ampiezza · Transizioni · Principi tattici'
}, {
  color: '🟣',
  title: 'VOLUME 5',
  subtitle: 'U14',
  desc: '50 Allenamenti Completi',
  features: 'Pressing · Costruzione dal basso · Decision Making · Situazioni reali di gara'
}];
const features = ['Programmazione annuale', 'Allenamenti completi', 'Obiettivi definiti', 'Progressioni tecniche', 'Varianti per livelli diversi', 'Adattamenti per gruppi ridotti', 'Monitoraggio dello sviluppo'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-242">
      <div className="max-w-5xl mx-auto" data-id="element-243">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-244">
          I 5 Volumi Completi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-245">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-246">
              <div className="flex items-center gap-3 mb-4" data-id="element-247">
                <span className="text-2xl" data-id="element-248">{tomo.color}</span>
                <div data-id="element-249">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-250">
                    {tomo.title}
                  </h3>
                  <p className="text-[#16A34A] font-bold text-lg leading-tight" data-id="element-251">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-252">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-253">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-254">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-255">
            Cosa include ogni volume
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-256">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-257">
                <span className="text-[#00C853] text-lg" data-id="element-258">✅</span> {f}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}